import { FB_EVENTS } from 'functions/analytics/constants/fbKeys';
import { AUTH_TYPE } from 'utils/constants/AuthenticationType';
import signUpEmail from './signUpEmail';
import signUpSMS from './signUpSMS';
import signUpGoogle from './signUpGoogle';
import signUpFacebook from './signUpFacebook';
import sendFbPixelRegistration from './sendFbPixelRegistration';
import { sendFbEventToConversionApi } from './sendFbEventToConversionApi';

export default (type) => {
  const events = {
    [AUTH_TYPE.EMAIL]: signUpEmail,
    [AUTH_TYPE.PHONE]: signUpSMS,
    [AUTH_TYPE.GOOGLE]: signUpGoogle,
    [AUTH_TYPE.FACEBOOK]: signUpFacebook,
  };

  // Send to conversions api
  const eventID = `${FB_EVENTS.REGISTRATION_EVENT}.${Date.now()}`;
  sendFbEventToConversionApi({
    eventName: FB_EVENTS.REGISTRATION_EVENT,
    customData: { method: type || AUTH_TYPE.EMAIL },
    eventID,
  }).catch((e) => console.error('Can\'t send facebook event', e));
  // Send to fb pixel
  sendFbPixelRegistration(type || AUTH_TYPE.EMAIL, eventID);
  // Send to gtag
  return (events[type] && events[type]()) || events[AUTH_TYPE.EMAIL]();
};
